// extracted by mini-css-extract-plugin
export default {"labelBox":"Label_labelBox__8RDDf","label":"Label_label__09h6V"};